import { render, staticRenderFns } from "./internbudgetadd-my.vue?vue&type=template&id=073ad42d"
import script from "./internbudgetadd-my.vue?vue&type=script&lang=js"
export * from "./internbudgetadd-my.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports